<template>
  <ModalCard
    :is-responsive="true"
    :data-e2e="FinancialAdvisorEstateCypressAttribute.modal.views.ADVISOR_PRO_UPSELL_MODAL"
  >
    <template #body>
      <section class="p-6">
        <div class="is-flex is-flex-direction-column">
          <div class="has-text-centered">
            <span class="is-size-2 has-text-weight-semibold has-text-primary">
              {{ $t('financialadvisor.pro-upsell-title') }}
            </span>
            <p class="has-text-weight-medium">
              {{ $t('financialadvisor.pro-upsell-subtitle') }}
            </p>
          </div>

          <div class="columns is-multiline mt-5">
            <div v-for="feature in features" :key="feature.titleKey" class="column is-4">
              <FinancialAdvisorUpsellFeatureCard
                :title="$t(feature.titleKey)"
                :description="$t(feature.descriptionKey)"
                :icon="feature.icon"
              />
            </div>
          </div>

          <div class="is-flex is-flex-direction-column is-align-items-center mt-5">
            <span class="has-text-weight-semibold is-size-3">
              {{ $t('financialadvisor.choose-your-advisor-pro-plan') }}
            </span>
            <span>{{ $t('financialadvisor.get-access-to-advisor-pro') }}</span>
          </div>
        </div>
        <FinancialAdvisorProBillingPlans class="m-t-20" :platform-product="platformProduct" />
        <FinancialAdvisorReferForFreeBanner @refer-client-clicked="onReferClientClicked" />
      </section>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import FinancialAdvisorUpsellFeatureCard from '@/modules/financialadvisor/components/presentational/FinancialAdvisorUpsellFeatureCard.vue';
import { AdvisorPortalEntryPoint } from '@/modules/financialadvisor/constants/AdvisorPortalEntryPoint';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute';
import { AdvisorPortalAdvisorProUpgradeStarted } from '@/modules/financialadvisor/models/segmentevents/AdvisorPortalAdvisorProUpgradeStarted';
import { PlatformProduct } from '@/modules/platformproduct/models/PlatformProduct';
import FinancialAdvisorProBillingPlans from '@/modules/financialadvisor/components/stateful/FinancialAdvisorProBillingPlans.vue';
import FinancialAdvisorReferForFreeBanner from '@/modules/financialadvisor/components/presentational/FinancialAdvisorReferForFreeBanner.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinancialAdvisorProUpsellModal',
  emits: ['on-refer-client-clicked'],
  components: {
    ModalCard,
    FinancialAdvisorUpsellFeatureCard,
    FinancialAdvisorProBillingPlans,
    FinancialAdvisorReferForFreeBanner
  },
  props: {
    platformProduct: {
      type: PlatformProduct
    },
    entryPoint: {
      type: String,
      default: AdvisorPortalEntryPoint.NAV
    }
  },
  static: {
    AdvisorPortalEntryPoint,
    FinancialAdvisorEstateCypressAttribute
  },
  computed: {
    features() {
      return [
        {
          titleKey: 'financialadvisor.unlimited-digital-vaults',
          descriptionKey: 'financialadvisor.unlimited-digital-vaults-desc',
          icon: 'cls-saving-safe'
        },
        {
          titleKey: 'financialadvisor.free-online-wills-for-clients',
          descriptionKey: 'financialadvisor.free-online-wills-for-clients-desc',
          icon: 'cls-legal-certificate'
        },
        {
          titleKey: 'financialadvisor.smart-opportunity-alerts',
          descriptionKey: 'financialadvisor.smart-opportunity-alerts-desc',
          icon: 'cls-light-bulb-shine-opportunity'
        },
        {
          titleKey: 'financialadvisor.analyze-client-existing-will',
          descriptionKey: 'financialadvisor.analyze-client-existing-will-desc',
          icon: 'cls-common-file-check-ai'
        },
        {
          titleKey: 'financialadvisor.build-family-trees',
          descriptionKey: 'financialadvisor.build-family-trees-desc',
          icon: 'cls-distribution'
        },
        {
          titleKey: 'financialadvisor.prefill-client-vaults',
          descriptionKey: 'financialadvisor.prefill-client-vaults-desc',
          icon: 'cls-content-paper-edit'
        }
      ];
    }
  },
  methods: {
    onReferClientClicked() {
      this.$emit('on-refer-client-clicked');
    }
  },
  mounted() {
    AdvisorPortalAdvisorProUpgradeStarted.dispatch(this.entryPoint);
  }
};
</script>

<style scoped>
:deep(.modal-card-body) {
  padding: 0 !important;
}
</style>
